<template>
  <b-modal
    ref="regimeModal"
    size="xs"
    centered
    modal-class="regime-modal"
    @hidden="hide"
  >
    <div slot="modal-title">
      {{ actionTitle }} <span style="text-transform: lowercase">{{ $tc('configuration.sections.regimes', 1) }}</span>
    </div>
    <b-row class="pt-2 pb-3 px-3">
      <b-col cols="12">
        <div class="form-label">
          <label>{{ $t('configuration.grid.externalCode') }}</label>
        </div>
        <vt-input
          ref="code"
          v-model="internalRegime.code"
          class="form-control-sm"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $tc('configuration.sections.regimes', 1) }}</label>
        </div>
        <ConfigurationNameTranslations :name-translations="internalRegime.nameTranslations" />
      </b-col>
      <b-col
        cols="12"
        class="mt-3 d-flex justify-content-end"
      >
        <div class="switch-btn mt-1 p-0 d-flex align-items-center">
          <span
            v-if="internalRegime.active"
            class="mr-2"
          >{{ $t('configuration.actions.active') }}</span>
          <span
            v-else
            class="mr-2"
          >{{ $t('configuration.actions.inactive') }}</span>
          <input
            id="toggle"
            v-model="internalRegime.active"
            type="checkbox"
            class="offscreen"
            aria-hidden="true"
          >
          <label
            for="toggle"
            class="switch mb-0"
          />
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            :disabled="!internalRegime.code || !internalRegimeHasDefaultLanguage"
            size="sm"
            class="btn--primary"
            @click="update()"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ actionTitle }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ConfigurationNameTranslations from '@/modules/configurationModule/detail/ConfigurationNameTranslations'
import languageService from '@/api/resources/common/languageService'
import { cloneDeep, isEmpty, uniqBy } from 'lodash'

export default {
    name: 'RegimeModal',
    components: { ConfigurationNameTranslations },
    props: {
        actionTitle: String
    },
    data() {
        return {
            internalRegime: {}
        }
    },
    computed: {
        internalRegimeHasDefaultLanguage() {
            let hasDefaultLanguage = false
            const defaultLanguage = this.internalRegime.nameTranslations.find(name => name.language.defaultLanguage)
            if (defaultLanguage) {
                hasDefaultLanguage = !!defaultLanguage.value.length
            }
            return hasDefaultLanguage
        }
    },
    methods: {
        async show(selectedRegime) {
            let allNameTranslations = []
            this.updateLoading(true)
            const [err, response] = await this.toCall(languageService.findAllActiveAndUiEnabled())
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            const activeUILanguages = response
            if (selectedRegime && !isEmpty(selectedRegime)) {
                this.internalRegime = cloneDeep(selectedRegime)
            } else {
                this.clearData()
            }
            const defaultNameTranslations = activeUILanguages.map(lang => {
                return {
                    language: lang,
                    notes: '',
                    value: ''
                }
            })
            allNameTranslations = uniqBy(this.internalRegime.nameTranslations.concat(defaultNameTranslations), 'language.id')
            this.internalRegime.nameTranslations = allNameTranslations
            this.$refs.regimeModal.show()
            this.$nextTick(() => {
                this.$refs.code.focus()
            })
        },
        hide() {
            this.$refs.regimeModal.hide()
        },
        update() {
            if (this.internalRegime.id) this.$emit('update', this.internalRegime)
            else this.$emit('create', this.internalRegime)
        },
        clearData() {
            this.internalRegime = {
                active: true,
                code: '',
                name: '',
                nameTranslations: []
            }
        }
    }
}
</script>

<style lang="scss">
    .regime-modal .translations-area {
        max-height: 100px;
        overflow-y: auto;
        padding-bottom: 3px;
    }
</style>
